import * as React from 'react';

function getComponent(component){
  return React.lazy(() => import(`../pages/${component}`));
}

const mappingUrl = [
  {
    name: 'home',
    path: '/',
    auth: true,
    Component: getComponent('home'),
  },
  {
    name: 'login',
    path: '/login',
    auth: false,
    Component: getComponent('loginGoogle'),
  },
  {
    name: 'error500',
    path: '/500',
    auth: false,
    Component: getComponent('Errors/500'),
  },


  // inquiry
  {
    name: 'inquiryEkyc',
    path: '/ekyc_inquiry',
    auth: true,
    Component: getComponent('Inquiry/Ekyc/list'),
  },
  {
    name: 'detailInquiryEkyc',
    path: '/ekyc_inquiry/:id',
    auth: true,
    Component: getComponent('Inquiry/Ekyc/detail'),
  },


  // myTask
  {
    name: 'ekyc',
    path: '/approval_ekyc',
    auth: true,
    Component: getComponent('MyTask/ApprovalEKyc/list'),
  },
  {
    name: 'detailEkyc',
    path: '/approval_ekyc/:id',
    auth: true,
    Component: getComponent('MyTask/ApprovalEKyc/detail'),
  },
  {
    name: 'editEkyc',
    path: '/approval_ekyc/edit/:id',
    auth: true,
    Component: getComponent('MyTask/ApprovalEKyc/form'),
  },
  {
    name: 'approvalMaintenance',
    path: '/approval_maintenance',
    auth: true,
    Component: getComponent('MyTask/ApprovalMaintenance/list'),
  },
  {
    name: 'detailApprovalMaintenance',
    path: '/approval_maintenance/:id',
    auth: true,
    Component: getComponent('MyTask/ApprovalMaintenance/detail'),
  },


  // report
  {
    name: 'reportStatus',
    path: '/report_status',
    auth: true,
    Component: getComponent('Report/ReportStatus/list'),
  },
  {
    name: 'registeredCustomer',
    path: '/registered_customer',
    auth: true,
    Component: getComponent('Report/RegisteredCustomer/form'),
  },
  {
    name: 'auditTrail',
    path: '/audit_trail',
    auth: true,
    Component: getComponent('Report/AuditTrail/list-audit'),
  },
  {
    name: 'detailAuditTrail',
    path: '/audit_trail/show',
    auth: true,
    Component: getComponent('Report/AuditTrail/show-audit'),
  },


  // maintenance
  {
    name: 'systemConfiguration',
    path: '/system_configuration',
    auth: true,
    Component: getComponent('Maintenance/SystemConfiguration/list'),
  },
  {
    name: 'detailSystemConfiguration',
    path: '/system_configuration/show/:id',
    auth: true,
    Component: getComponent('Maintenance/SystemConfiguration/detail'),
  },
  {
    name: 'updateSystemConfiguration',
    path: '/system_configuration/:moduleType/:id',
    auth: true,
    Component: getComponent('Maintenance/SystemConfiguration/form'),
  },
  {
    name: 'approveSystemConfiguration',
    path: '/approval_maintenance/systemConfiguration/:taskType/:id',
    auth: true,
    Component: getComponent('Maintenance/SystemConfiguration/approval'),
  },


  // security
  {
    name: 'role',
    path: '/role',
    auth: true,
    Component: getComponent('Security/Role/list'),
  },
  {
    name: 'createRole',
    path: '/role/:moduleType',
    auth: true,
    Component: getComponent('Security/Role/form'),
  },
  {
    name: 'showRole',
    path: '/role/show/:id',
    auth: true,
    Component: getComponent('Security/Role/detail'),
  },
  {
    name: 'editRole',
    path: '/role/:moduleType/:id',
    auth: true,
    Component: getComponent('Security/Role/form'),
  },
  {
    name: 'approvalRole',
    path: '/approval_maintenance/role/:taskType/:id',
    auth: true,
    Component: getComponent('Security/Role/approval'),
  },
  {
    name: 'user',
    path: '/user',
    auth: true,
    Component: getComponent('Security/User/list'),
  },
  {
    name: 'createUser',
    path: '/user/:moduleType',
    auth: true,
    Component: getComponent('Security/User/form'),
  },
  {
    name: 'editUser',
    path: '/user/:moduleType/:id',
    auth: true,
    Component: getComponent('Security/User/form'),
  },
  {
    name: 'showUser',
    path: '/user/show/:id',
    auth: true,
    Component: getComponent('Security/User/detail'),
  },
  {
    name: 'approvalUser',
    path: '/approval_maintenance/user/:taskType/:id',
    auth: true,
    Component: getComponent('Security/User/approval'),
  },

];

export default mappingUrl;
